import { IDistinctColor } from "@interfaces/modelColorDetails";

export interface ColorComparatorCardData {
  colors: IDistinctColor[];
  side: "left" | "right";
  brand: string;
  model: string;
  value: string;
  level?: "variant" | "modal";
  title?: string;
  pageType?: string;
  carAvailability?: string;
  cityName?: string;
  modalOptions?: {
    openModalText: string;
    confirmButtonText: string;
    includePricingAndDelivery?: boolean;
    hidePricingAndDelivery?: boolean;
  };
}

export const defaultColorComparatorData: ColorComparatorCardData = {
  colors: [],
  side: "left",
  brand: "",
  model: "",
  value: "",
  level: "modal",
  title: "Select Colour",
  modalOptions: {
    openModalText: "Open Colour Selection",
    confirmButtonText: "Confirm Selection",
    includePricingAndDelivery: false,
    hidePricingAndDelivery: true,
  },
};
